import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Jacky zum ersten Mal wieder normalen Stuhlgang. Wir sind so erleichtert.',
  author: 'Sandra (Hund: Jacky, Labrador, 4 Jahre)',
  photo: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=100&h=100&q=80'
}, {
  text: 'Rex hatte wochenlang keinen Stuhlgang und sichtbare Schmerzen beim Drücken. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.',
  author: 'Thomas (Hund: Rex, Mischling, 7 Jahre)',
  photo: 'https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=100&h=100&q=80'
}, {
  text: 'Mein Hund hat sich schnell an das Topping gewöhnt – nach dem Darmverschluss war das unsere Rettung. Ich bin super zufrieden.',
  author: 'Julia (Hund: Balu, Golden Retriever, 5 Jahre)',
  photo: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?auto=format&fit=crop&w=100&h=100&q=80'
}];
export function Testimonials() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-147">
      <h2 className="text-center font-handwritten text-4xl text-forest-green font-bold mb-10" data-id="element-148">
        Erfahrungen anderer Hundehalter
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-149">
        {reviews.map((review, index) => <motion.div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-warm-brown/10 flex flex-col h-full" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.15
      }} data-id="element-150">
            <div className="flex items-center gap-3 mb-4" data-id="element-151">
              <img src={review.photo} alt={review.author.split(' (')[0] + 's Hund'} className="w-10 h-10 rounded-full object-cover border border-warm-brown/20 shrink-0" data-id="element-152" />
              <div data-id="element-153">
                <p className="font-bold text-sm text-gray-800 leading-tight" data-id="element-154">
                  {review.author.split(' (')[0]}
                </p>
                <p className="text-xs text-gray-500" data-id="element-155">
                  ({review.author.split('(')[1]}
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-3 text-yellow-400" data-id="element-156">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-157" />)}
            </div>

            <p className="text-gray-700 leading-relaxed flex-grow text-sm" data-id="element-158">
              "{review.text}"
            </p>
          </motion.div>)}
      </div>
    </section>;
}